require("../../gallery/gallery");

import "../../gallery/widget.scss";
